<template>
  <div class="membership-data">
    <div class="membership-data-top">
      <span>会员数据</span>
    </div>
    <div class="membership-data-bottom">
      <div class="membership-data-search">
        <el-input v-model="nickname" clearable placeholder="请输入会员昵称"></el-input>
        <el-input v-model="openid" clearable placeholder="请输入openid"></el-input>
        <el-input v-model="plateNumber" clearable placeholder="请输入车牌号"></el-input>
        <el-button class="btn-search" @click="searchClick()">查询</el-button>
        <el-button class="btn-blacklist" @click="blacklistClick()">黑名单</el-button>
        <div style="clear:both;"></div>
      </div>
      <div class="membership-data-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="nickname"
            label="会员名称"
            width="">
            <template slot-scope="scope">{{ scope.row.nickname | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="openid"
            label="openid"
            width="">
            <template slot-scope="scope">{{ scope.row.openid | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="phone_number"
            label="手机号"
            width="180">
            <template slot-scope="scope">{{ scope.row.phone_number | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="car_model"
            label="车型"
            width="180">
            <template slot-scope="scope">{{ scope.row.car_model | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="plate_number"
            label="车牌号"
            width="180">
            <template slot-scope="scope">{{ scope.row.plate_number | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="contract_status"
            label="免密状态"
            width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.contract_status==null">未签免密代扣协议</span>
              <span v-else-if="scope.row.contract_status==1" class="signed">已签约</span>
              <span v-else-if="scope.row.contract_status==2" class="terminated">已解约</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="timestamp"
            label="创建时间"
            width="160">
            <template slot-scope="scope">{{ scope.row.timestamp | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="last_login_time"
            label="最后登录时间"
            width="160">
            <template slot-scope="scope">{{ scope.row.last_login_time | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button class="btn-disabled btn-enable" v-if="scope.row.status==2" @click="enableClick(scope.row)" :disabled="prohibitPrivilege==1" :class="[prohibitPrivilege==1?'active':'']">启用</el-button>
              <el-button class="btn-disabled" v-else-if="scope.row.status==1" @click="blacklistBtn(scope.row)" :disabled="prohibitPrivilege==1" :class="[prohibitPrivilege==1?'active':'']">禁用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <!-- 黑名单 -->
    <el-dialog
		:visible.sync="blacklistDialog"
    customClass="blacklist-dialog"
		width="934px"
    :close-on-click-modal="false"
		>
      <p class="title">黑名单</p>
      <div class="line"></div>
      <div class="blacklist-table-d">
        <el-table
          :data="blacklistData"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="nickname"
            label="昵称"
            width="120">
            <template slot-scope="scope">{{ scope.row.nickname | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="openid"
            label="openid"
            width="">
            <template slot-scope="scope">{{ scope.row.openid | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="disabled_reason"
            label="理由">
            <template slot-scope="scope">{{ scope.row.disabled_reason | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="disabled_time"
            label="时间"
            width="155">
            <template slot-scope="scope">{{ scope.row.disabled_time | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button class="disabled-dia" @click="jinyClick(scope.row)" :disabled="prohibitPrivilege==1" :class="[prohibitPrivilege==1?'active':'']">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 禁用 -->
    <el-dialog
		:visible.sync="prohibitDialog"
    customClass="prohibit-dialog"
		width="934px"
    @close="prohibitCancelClick"
    :close-on-click-modal="false"
		>
      <p class="title">禁用</p>
      <div class="line"></div>
      <div class="prohibit-reason">
        <div class="text"><span class="star">*</span>禁用理由：</div>
        <div class="reason-box">
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 4 }"
            placeholder="请输入禁用理由"
            v-model="prohibitReason">
          </el-input>
        </div>
      </div>
      <div class="pro-button">
        <el-button class="pro-btn pro-cancel" @click="prohibitCancelClick()">取消</el-button>
        <el-button class="pro-btn pro-confirm" @click="prohibitConfirmClick()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      blacklistDialog:false,
      prohibitDialog:false,
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      input:"",
      nickname:"",
      openid:"",
      plateNumber:"",
      blacklistData:[],
      prohibitReason:"",
      prohibitId:"",
      prohibitPrivilege:1,//禁用/启用
    }
  },
  mounted() {
    this.$nextTick(function() {
      

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "会员管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "会员数据"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "启用/禁用会员"){
                  this.prohibitPrivilege = 0;
                }
              }
            }
          }
        }
      }

      this.getDataList();
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(nickname,openid,number){

      if(nickname == undefined){
        nickname = "";
      }
      if(openid == undefined){
        openid = "";
      }
      if(number == undefined){
        number = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getMembers",
        nickname:nickname,
        openid:openid,
        plate_number:number,
      };
      this.$api({
          method: "post",
          url: "/api.php/Member/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.tableData = su.data.list;
                this.totalNum = this.tableData.length;
                if(this.totalNum > 10){
                  // debugger
                  this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                } else {
                  this.yemiandata=this.tableData;
                }
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.nickname,this.openid,this.plateNumber);
    },
    blacklistClick(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getDisabledMemberList",
      };
      this.$api({
          method: "post",
          url: "/api.php/Member/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.blacklistDialog = true;
                this.blacklistData = su.data.list;
                // this.totalNum = this.tableData.length;
                // if(this.totalNum > 10){
                //   this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                // } else {
                //   this.yemiandata=this.tableData;
                // }
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    blacklistBtn(row){
      this.prohibitDialog = true;
      this.prohibitReason = "";
      this.prohibitId = row.openid;
    },
    prohibitCancelClick(){
      this.prohibitDialog = false;
      this.prohibitReason = "";
      this.prohibitId = "";
    },
    prohibitConfirmClick(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"disableMember",
        openid:this.prohibitId,
        disabled_reason:this.prohibitReason,
      };
      this.$api({
          method: "post",
          url: "/api.php/Member/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.prohibitDialog = false;
                this.prohibitReason = "";
                this.prohibitId = "";
                this.getDataList();
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    enableClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"enableMember",
        openid:row.openid,
      };
      this.$confirm("确定启用", "启用", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Member/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList();
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    jinyClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"enableMember",
        openid:row.openid,
      };
      this.$confirm("确定启用", "启用", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Member/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.blacklistClick();
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  },
}
</script>

<style scoped lang="scss">
.membership-data {
  .membership-data-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .membership-data-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 12px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 14px;
    .membership-data-search {
      width: 98%;
      margin-left: 1%;
      .el-input {
        width: 12%;
        float: left;
        margin-right: 10px;
      }
      .btn-search {
        background-color: #0071bd;
        border:none;
        color: #feffff;
        float: left;
      }
      .btn-search:active {
        background-color: #409EFF;
      }
      .btn-blacklist {
        background-color: #f15500;
        border:none;
        color: #feffff;
        float: left;
      }
    }
    .membership-data-table {
      margin-top: 28px;
      width: 98%;
      margin-left: 1%;
      .btn-disabled {
        background-color: #eb0000;
        color: #feffff;
        border:none;
        width: 54px;
        height: 26px;
        padding: 0;
        font-size: 12px;
      }
      .btn-disabled.active {
        background-color: #a5a5a5;
      }
      .btn-enable {
        background-color: #00b74d;
      }
      .signed {
        color:#458BC6;
      }
      .terminated {
        color:#00B270;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .blacklist-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: 100%;
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .blacklist-table-d {
      .disabled-dia {
        background-color: #00b74d;
        color: #feffff;
        border:none;
        width: 54px;
        height: 26px;
        padding: 0;
        font-size: 12px;
      }
      .disabled-dia.active {
        background-color: #a5a5a5;
      }
    }
  }
  .prohibit-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .prohibit-reason {
      width: 90%;
      // margin-left: 4%;
      .text {
        display: inline-block;
        width: 26%;
        text-align: right;
        vertical-align: top;
        .star {
          color:#EE0002;
          margin-right: 6px;
        }
      }
      .reason-box {
        display: inline-block;
        width: 70%;
      }
    }
    .pro-button {
      margin-top: 40px;
      .pro-cancel {
        width: 26%;
        height: 50px;
        background-color: #0071BD;
        border:none;
        color:#ffffff;
      }
      .pro-confirm {
        width: 26%;
        height: 50px;
        background-color: #02B36F;
        border:none;
        color:#ffffff;
      }
    }
  }
}
</style>
<style lang="scss">
.membership-data .el-table--enable-row-hover .el-table__body tr:hover>td {
  .signed {
    color:#ffffff;
  }
  .terminated {
    color:#ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/membershipManagement/membershipData.vue